module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'circle-container glyphicon ' + _vm.getIconClass()
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54d66340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/CommentIcon.vue
// module id = 1451
// module chunks = 1